export default __webpack_public_path__ + "static/media/t2.b02e5698.png";